export default __webpack_public_path__ + "static/SCROLL_1-fcb9875946fa43c9e3ebccc742249b89.png";